import {
    INFORMATION_SCREEN,    
    GATED_MULTIPLE_CHOICE_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE,
    MULTIPLE_CHOICE_WITH_TITLE_AND_TEXT_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE,
    TEXT_ANSWER_QUESTION_TYPE,
    GATED_TEXT_ANSWER_QUESTION_TYPE,
    YES_NO_QUESTION_TYPE
} from './consts/questionTypes';

export const questions = [
    {
        id: 1,
        type: INFORMATION_SCREEN,
        information: 'Med denne generatoren lager du en personvernerklæring som er tilpasset din bedrift.',
        description: 'Svarene du gir lagres ikke hos oss men lagres i nettleseren din, og brukes til å lage en ferdig personvernerklæring.'
    },
    {
        id: 2,
        type: YES_NO_QUESTION_TYPE,
        question: 'Samler du inn personopplysninger fra brukerne dine?',
        description: 'For eksempel gjennom et registreringsskjema, eller informasjon brukerne dine oppgir til din virksomhet i andre sammenhenger.'
    },
    {
        id: 3,
        type: YES_NO_QUESTION_TYPE,
        question: 'Samler du inn klikkdata fra brukerne dine?',
        description: 'For eksempel lese og handlingshistorikk fra bruk av app, nettsider eller eposter.'
    },    
    {
        id: 4,
        type: GATED_MULTIPLE_CHOICE_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE,
        condition:
        {
            ask: 'Henter du inn data fra tredjeparter?',
            description: 'For eksempel adressevask, kredittinformasjon eller nummeropplysningstjenester.'
        },
        question: 'Hvilke tredjeparter henter du data fra?',
        description: 'Her velger du, eller legger til, hvilkehvilke type tredjeparter du henter personopplysninger fra. Du kan endre forhåndsdefinerte kategorier samt legge til nye.',
        answers: ['Adressevask', 'Kredittvurdering', 'Nummeropplysningstjenester']
    },
    {
        id: 5,
        type: MULTIPLE_CHOICE_WITH_TITLE_AND_TEXT_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE,
        question: 'Hvilke type personopplysninger behandler du?',
        description: 'Her velger du, eller legger til, hvilke katogorier av personopplysninger behandler. Du kan endre forhåndsdefinerte kategorier samt legge til nye.',
        answers: [
            {
                title: 'Grunnleggende informasjon',
                text: `Navn, fødselsdato`
            },
            {
                title: 'Kontaktinformasjon',
                text: `Adresse, telefonnummer, epostadresse`
            },
            {
                title: 'Konto og profilinformasjon',
                text: `Innstillinger, preferanser`
            },
            {
                title: 'Betalingsinformasjon',
                text: `Transaksjonsinformasjon, betalingsmiddel`
            },
            {
                title: 'Kundehistorikk og kundeengasjement',
                text: `Bestillings- og leveringsopplysninger, handlekurvbevegelser, rabattkoder, lojalitetsprograminformasjon, aktive produkter og avtaler samt produkter og tjenester du har hatt tidligere, hvor mye og hvor ofte de brukes, status på produkter/tjenester`
            },
            {
                title: 'Kundeaktivitet',
                text: `Lese- og handlingshistorikk fra app, nettsider eller elektronisk kommunikasjon vi sender ut. Samt teknisk informasjon om enhetene du bruker.`
            }
        ]
    },
    {
        id: 6,
        type: MULTIPLE_CHOICE_WITH_TITLE_AND_TEXT_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE,
        question: 'Hvilke type behandlinger gjør du?',
        description: 'I tillegg til å oppgi hvilke typer personopplysninger virksomheten behandler, må du også oppgi hva du bruker de til. Vi har forhåndsdefinert de mest vanlige behandlingene. Du kan endre forhåndsdefinerte kategorier samt legge til nye.',
        answers: [
            {
                title: 'Levering av tjeneste/avtaleinngåelse',
                text: `Vi bruker dine personopplysninger til å oppfylle våre avtaler med deg, det vil si når du har bestilt et produkt eller en tjeneste fra oss. Det rettslige grunnlaget for å behandle personopplysninger til dette formålet er at behandlingen er nødvendig for å oppfylle en avtale med deg.`
            },
            {
                title: 'Administrasjon av kundeforhold',
                text: `Vi bruker dine personopplysninger til å administrere vårt kundeforhold med deg. Det kan for eksempel være kundeservice, klagebehandling og feilretting vedrørende ditt kundeforhold. Det rettslige grunnlaget for å behandle personopplysninger til dette formålet er at behandlingen er nødvendig for å oppfylle en avtale med deg.`
            },
            {
                title: 'Analyse, forretningsutvikling og forbedring av tjenester',
                text: `Vi arbeider kontinuerlig med å utvikle og forbedre våre tjenester og produkter. Mye av dette arbeidet innebærer å analysere ulike former for personopplysninger, som for eksempel kundeaktivitet, kundehistorikk og konto og profilinformasjon. Det rettslige grunnlaget for å behandle personopplysninger til dette formålet er vår berettigede interesse.`
            },
            {
                title: 'Tilpasset brukeropplevelse',
                text: `Vi tilpasser brukeropplevelsen og kommunikasjonen til ditt kundeforhold og dette bruker vi personopplysninger til. Det rettslige grunnlaget for å behandle personopplysninger til dette formålet er vår berettigede interesse.`
            },
            {
                title: 'Salg og markedsføring',
                text: `Vi bruker personopplysninger i forbindelse med salg og markedsføring av våre produkter og tjenester, for eksempel ved at du mottar epost fra oss. Det rettslige grunnlaget for å behandle personopplysninger til dette formålet er vår berettigede interesse. Du har mulighet å reservere deg fra deler av denne behandlingen ved å, for eksempel, reservere deg fra å motta epost fra oss. I tillegg til dette kan vi også be deg om samtykke til å bruke dine personopplysninger til såkalt profilering, hvor vi utleder interesser og behov på bakgrunn av dine personopplysninger. Hensikten med profilering vil være at markedsføringen vår skal bli mer relevant.`
            },
            {
                title: 'Systemovervåking, feilretting mm.',
                text: `Vi overvåker våre systemer etter feil og problemer. En del av disse prosessene innebærer lagring og behandling av personopplysninger. Det rettslige grunnlaget for å behandle personopplysninger til dette formålet er vår berettigede interesse.`
            },
            {
                title: 'Sikkerhet, avdekking av svindel og kriminelle handlinger',
                text: `Vi behandler personopplysninger i vårt arbeid med å beskytte våre brukere og oss selv mot svindelaktivitet, misbruk og kriminelle handlinger. Det rettslige grunnlaget for å behandle personopplysninger til dette formålet er vår berettigede interesse.`
            },
            {
                title: 'Overholde rettslige forpliktelser',
                text: `I enkelte tilfeller er vi pålagt å behandle personopplysninger av hensyn til andre rettslige forpliktelser. Et eksempel på dette er informasjon knyttet til salg, som vi er pliktig til å regnskapsføre og oppbevare i henhold til bokføringsloven. Det rettslige grunnlaget for å behandle personopplysninger til dette formålet er at behandlingen er nødvendig for å oppfylle en rettslig forpliktelse som påhviler oss.`
            }
        ]
    },
    {
        id: 7,
        type: TEXT_ANSWER_QUESTION_TYPE,
        question: 'Hva er navnet på selskapet som er behandlingsansvarlig?',
        description: 'Dette er samme navn som er registert i Brønnøysundregisteret.'
    },    
    {
        id: 8,
        type: GATED_TEXT_ANSWER_QUESTION_TYPE,
        condition:
        {
            ask: 'Skal personvernerklæringen brukes på en nettside?',
            description: 'For eksempel hjemmeside, nettbutikk, etc.'
        },
        question: 'Hva er adressen/url til nettsiden?',
        description: 'Legg inn adressen til nettsiden som skal benytte denne personvernerklæringen.'
    },
    {
        id: 9,
        type: GATED_TEXT_ANSWER_QUESTION_TYPE,
        condition:
        {
            ask: 'Skal personvernerklæringen brukes i en app?',
            description: 'Applikasjoner på brukerens device, f.eks. fra Apple App Store eller Google Play.'
        },
        question: 'Hva er navnet på appen?',
        description: 'Legg inn navnet på appen som skal benytte denne personvernerklæringen. '
    },
    {
        id: 10,
        type: GATED_TEXT_ANSWER_QUESTION_TYPE,
        condition:
        {
            ask: 'Bruker dere cookies?',
            description: 'Personvernerklæringen bør inneholde en link til en cookie-erklæringen hvis cookies benyttes i løsningen.'
        },
        question: 'Hva er linken til cookie-erklæringen?',
        description: 'Legg inn adressen til nettsiden med cookie-erklæringen.'
    },
    {
        id: 11,
        type: TEXT_ANSWER_QUESTION_TYPE,
        question: 'Kontaktinformasjon for personvernforespørsler',
        description: 'Hva er epostadressen som dine kunder/besøkende kan bruke for henvendelser relatert til personvern eller personvernerklæringen?'
    }
];
